export class QuickNavigator {
    constructor() {
        this.$form = $('.js-quick-navigator');
        this.$menuPrimary = this.$form.find('select[name="c-quick-navigator__menu--primary"]');
        this.$menuSecondary = this.$form.find('select[name="c-quick-navigator__menu--secondary"]');
        this.$submitBtn = this.$form.find('.js-quick-navigator-submit');

        this.$form.on('submit', (e) => this.onSubmitForm(e));
    }

    onSubmitForm(e) {
        e.preventDefault();
        const menuPrimary = this.$menuPrimary.val() || '';
        const menuSecondary = this.$menuSecondary.val() || '';

        if (('' === menuPrimary && '' === menuSecondary) || this.$submitBtn.prop('disabled') === true) return false;

        this.$submitBtn.append('<i class="fa fa-spin fa-spinner"></i>');
        this.$submitBtn.prop('disabled', true);

        let url = location.origin;
        if('' !== menuPrimary) url += menuPrimary;
        if('' !== menuSecondary) url+= menuSecondary;

        this.redirectTo(url);
    }

    /**
     * Redirects user
     * @param url
     */
    /* istanbul ignore next */
    redirectTo(url) {
        window.location.href = url;
    }
}
